import { CoreMenu } from '@core/types';

export const tutorMenu: CoreMenu[] = [
  {
    id: 'internship-tutor-home',
    title: 'Dashboard',
    translate: 'menu_tutor_dashboard',
    type: 'item',
    icon: 'home',
    url: 'tutor',
    exactMatch: true
  },
  {
    id: 'registrations-review',
    title: 'Revisione Registrazioni',
    translate: 'menu_tutor_registrations_review',
    type: 'item',
    icon: 'check-square',
    url: 'tutor/registrations',
    permissions: ['internship.tutor_review.view']
  },
  {
    id: 'students',
    title: 'I Miei Studenti',
    translate: 'menu_tutor_my_students',
    type: 'item',
    icon: 'users',
    url: 'tutor/students',
    permissions: ['internship.tutor_review.view']
  }
];
